module.exports = __webpack_public_path__ + "media/images/logo/logo-edd1ec117d6a959bfbadc7163a03e724.png";